
/*
 *   File : request-list.js
 *   Author URI : https://evoqins.com
 *   Description : Page for list B2B KYC request 
 *   Integrations : null
 *   Version : v1.1
 */

/* import packages */
import React, { useEffect, useState, Fragment } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Modal } from "bootstrap";

/* import components */
import { NavigationHeader } from "../../Components/Header";
import { SectionTitle } from "../../Components/Title";
import { DataTableContainer, SearchInput } from "../../Components/FormElements";
import { GradientButton, LinkText, SecondaryButton } from "../../Components/Cta";
import { Icon } from "../../Components/Icon";
import { CustomLoader, EmptyScreen } from "../../Components/Other";
import { KYCRequestSuccess, CreateUserAccount } from "../../Components/Modal";
/* import styles */
import Colors from '../../Styles/color.module.scss';

/* import services */
import APIService from "../../Services/api-service";
import { _sortDate } from "../../Helper/helper-function";


export default React.memo(function WhiteLabelSettingsList(props) {
    const navigate = useNavigate();
    // const location = useLocation();
    // const ADMIN_PROFILE_DATA = useSelector(state => state.MT_ADMIN_STORE.ADMIN_PROFILE);

    const [loader, setLoader] = useState(false);
    const [paginationData, setPaginationData] = useState({});
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [pageSize, setPageSize] = useState(12);
    const [totalLength, setTotalLength] = useState(3);
    const [searchQuery, setSearchQuery] = useState("");
    console.log('searchQuery', searchQuery);

    const [listData, setListData] = useState([]);

    console.log('listData', listData);

    useEffect(() => {
        if (searchQuery.length === 0) {
            _getLabelSettingsList();
        }
    }, [searchQuery]);


    const TABLE_COLUMNS = [

        {
            name: 'Sl.no',
            selector: row => row.id,
            sortable: false,
            left: true,
            width: "150px",
            cell: (row, index) =>
                <p className="color-black e-poppins-regular e-font-16 line-height-24px mb-0 mt-0 gap-12px color-outer-space">
                    {index + 1}
                </p>
        },
        {
            name: 'Distributor name',
            selector: row => row.distributor_name,
            sortable: false,
            left: true,
            minWidth: "250px",
            cell: row =>
                <p className="color-primary-color e-poppins-regular e-font-16 line-height-24px mb-0 mt-0 gap-12px ">
                    {row.distributor_name}
                </p>,
        },
        {
            name: 'Distributor code',
            selector: row => row.distributor_code,
            sortable: false,
            left: true,
            minWidth: "200px",
            cell: row =>
                <p className="color-primary-color e-poppins-regular e-font-16 line-height-24px mb-0 mt-0 gap-12px ">
                    {row.distributor_code || '-'}
                </p>
        },
        {
            name: 'URL',
            selector: row => row.domain_url,
            sortable: false,
            left: true,
            minWidth: "290px",
            cell: row =>
                <p className="color-black e-poppins-regular e-font-16 line-height-24px mb-0 mt-0 color-outer-space">
                    {row.domain_url}
                </p>
        },
        {
            name: 'Status',
            selector: row => row.status,
            sortable: false,
            center: true,
            minWidth: "100px",
            cell: row =>

                <p className={`${row.status === false ? 'color-red' : 'color-green'} e-poppins-regular e-font-16 line-height-24px mb-0 mt-0 `}>
                    {row.status === false ? 'Inactive' : 'Active'}
                </p>
        },
        {
            name: '',
            sortable: false,
            right: true,
            maxWidth: "100%",
            cell: row =>
                <>
                    <LinkText title="View details"
                        icon="arrow-right"
                        className="d-flex "
                        onClick={() => _handleRowClick(row)} />
                </>

        }

    ];

    const TABLE_STYLE = {
        table: {
            style: {
                padding: "12px 16px 16px 16px",
                background: Colors.white,
            },
        },

        tableBody: {
            style: {
                margin: '0px',
                marginTop: "0px !important"
            }
        },
        headRow: {
            style: {
                background: '#F1F6FF',
                borderRadius: "16px 16px 0px 0px",
                border: "0",
                borderBottom: `1px solid ${Colors.bright_gray} !important`,
                fontSize: "14px",
                fontFamily: "Poppins-Medium",
                lineHeight: "24px",
                color: Colors.outer_space
            }
        },
        rows: {
            style: {
                '&:last-child': {
                    borderBottomLeftRadius: "12px",
                    borderBottomRightRadius: "12px",
                    '&:hover': {
                        boxShadow: '0px 6px 8px 0px rgba(50, 50, 71, 0.05)',
                    },
                },
                margin: "0",
                background: "transparent",
                border: `1px solid ${Colors.bright_gray} !important`,
                borderRadius: "0px",
                marginTop: "0px",
                fontSize: "16px",
                fontFamily: "Poppins-Regular",
                lineHeight: "24px",
                // cursor: "pointer",
                '&:hover': {
                    boxShadow: '0px 12px 16px 0px rgba(50, 50, 71, 0.08)',
                },
            },
        },
        cells: {
            style: {
                '&:not(:last-child)': {
                    paddingLeft: '0px',
                    paddingRight: '0px',
                    display: 'flex',
                },
                '&:first-child': {
                    padding: "24px 0px 24px 24px",
                }
            },
        },
        headCells: {
            style: {
                '&:not(:last-child)': {
                    paddingLeft: '0px',
                    paddingRight: '0px',
                    display: 'flex',
                },
                '&:first-child': {
                    padding: "24px 0px 24px 24px",
                }
            },
        },
        pagination: {
            style: {
                borderTop: `none`,
                color: Colors.outer_space,
                fontSize: '16px',
                fontFamily: "Poppins-Regular",
            },
        }
    }

    // handle table row click
    function _handleRowClick(row_data) {
        navigate("/white-label-settings/detail", {
            state: {
                detail_id: row_data.id
            }
        });
    }

    const _handleSearchQuery = (value) => {
        setPageNumber(1);
        setSearchQuery(value);

    }

    // handle new request button click
    function _createNewList() {
        navigate("/white-label-settings/create-list");
    }



    // handler for page change
    function _nextPage() {
        setPageNumber(prevCount => prevCount + 1);
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }


    // got to previous page
    function _previousPage() {
        setPageNumber(prevCount => prevCount - 1);
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };


    // API - get kyc request data
    function _getLabelSettingsList() {
        setLoader(true);
        let is_post = true;
        let url = 'white-label/list-distributors';
        let payload = {
            "query": searchQuery
        }
        APIService(is_post, url, payload).then((response) => {
            if (response.status_code === 200) {
                setListData(response.data);
                setPaginationData({ rowsPerPageText: `${response.data.page} | Total records: ${response.data.number_of_records}` })
                let total_pages = Math.ceil(response.data.number_of_records / response.data.page_size);
                setTotalPages(total_pages);
            }
            setLoader(false);
        })
    };

    return (

        <Fragment>
            <NavigationHeader
                type={1}
                title="White Label Settings" />
            <div className="ps-4 pe-lg-5 pe-md-2 pe-2 padding-42px-top">
                <div className="row padding-32px-bottom">
                    <div className="col-lg-6 col-md-7 col-6">
                        <SectionTitle title="Distributor list" />
                    </div>
                    <div className="col-lg-6 col-md-5 col-6  d-flex gap-4  align-items-center justify-content-end">
                        <SearchInput placeholder="Search with name or url"
                            value={searchQuery}
                            valueChange={_handleSearchQuery}
                            handleSearch={_getLabelSettingsList} />

                        <GradientButton label="Add new "
                            className='padding-10px-tb'
                            onPress={_createNewList} />
                    </div>
                </div>

                {/* Table */}
                <>
                    {
                        loader === true ?
                            <CustomLoader />
                            :
                            <>
                                {
                                    listData.length !== 0 ?
                                        <div className="min-height-80vh">
                                            <div className="col-12 text-end mt-2">
                                                <p className="color-outer-space e-poppins-regular e-font-12 mb-0">
                                                    <img draggable={false} src={require('../../Assets/Images/Onboarding/scroll-gif.gif')} alt="scroll"
                                                        width='24px'
                                                        height='24px'
                                                        className='e-rotate-gif' />
                                                    Scroll horizontally for view more  information</p>
                                            </div>
                                            <div className="col-12 position-relative" id="e-table-body">
                                                <DataTableContainer columns={TABLE_COLUMNS}
                                                    data={listData}
                                                    selectableRows={false}
                                                    pagination={false}
                                                    customStyles={TABLE_STYLE}
                                                    paginationTotalRows={totalLength}
                                                    paginationComponentOptions={paginationData}
                                                    onChangeRowsPerPage={(e) => {
                                                        setPageSize(e);
                                                        setPageNumber(1);
                                                    }}
                                                    paginationPerPage={pageSize}
                                                />

                                                {/* <div className={`d-flex justify-content-end align-items-center mt-3 position-absolute bottom-16px right-24 w-max-content`}>
                                                    <Icon icon="pagination-previous" width="24px" height="24px"
                                                        className={pageNumber === 1 ? 'pointer-events-none opacity-4 mx-3' : 'mx-3 cursor-pointer'}
                                                        onClick={_previousPage} />
                                                    <Icon icon="pagination-next" width="24px" height="24px"
                                                        className={pageNumber === totalPages ? 'ms-1 pointer-events-none opacity-4' : 'ms-1 cursor-pointer'}
                                                        onClick={_nextPage} />
                                                </div> */}

                                            </div>
                                        </div>
                                        :
                                        <div className="mb-5">
                                            <EmptyScreen title="Empty KYC request!" />
                                        </div>
                                }
                            </>
                    }
                </>

            </div>


        </Fragment>
    )
});